import biLogger from '@wix/web-bi-logger';
import {
  pageViewSrc10Evid5000,
  ggEcomOnboardingFunnelSummarySrc10Evid5010,
  ggGeneralActionSrc10Evid5001,
  ggFunnelErrorStateSrc10Evid5011,
} from '@wix/bi-logger-stores-data/v2';
import {
  pageViewSrc10Evid5000Params,
  ggGeneralActionSrc10Evid5001Params,
  ggEcomOnboardingFunnelSummarySrc10Evid5010Params,
  ggFunnelErrorStateSrc10Evid5011Params,
} from '@wix/bi-logger-stores-data/v2/types';
import { FLOW_NAME_PREFIX } from 'config/bi-events';
import { getUrlParam } from '@wix/gg-common-lib/utils';

const logger = biLogger.factory({}).logger();

const baseParams = {
  flow: FLOW_NAME_PREFIX,
};

const stepViewed = (params: Omit<pageViewSrc10Evid5000Params, 'flow' | 'referral_info'>) => {
  const referral_info = getUrlParam('utm_campaign') ?? getUrlParam('referralInfo') ?? undefined;
  logger.report(pageViewSrc10Evid5000({ ...baseParams, ...params, referral_info }));
};

const actionClicked = (params: Omit<ggGeneralActionSrc10Evid5001Params, 'flow'>) => {
  logger.report(ggGeneralActionSrc10Evid5001({ ...baseParams, ...params }));
};

const flowSummary = (params: Omit<ggEcomOnboardingFunnelSummarySrc10Evid5010Params, 'flow'>) => {
  logger.report(ggEcomOnboardingFunnelSummarySrc10Evid5010({ ...baseParams, ...params }));
};

const errorState = (params: Omit<ggFunnelErrorStateSrc10Evid5011Params, 'flow'>) => {
  logger.report(ggFunnelErrorStateSrc10Evid5011({ ...baseParams, ...params }));
};

export const biEvents = {
  stepViewed,
  actionClicked,
  flowSummary,
  errorState,
};
